import PropTypes from 'prop-types';
import React from 'react';
import { Panel } from 'react-bootstrap';

class CommissionBadge extends React.Component {
  render() {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      // the default value for minimumFractionDigits depends on the currency
      // and is usually already 2
    });
    const sum = formatter.format(this.props.value);
    return (
      <div className="col-sm-3">
        <Panel header={this.props.title}>
          <h2>{sum}</h2>
        </Panel>
      </div>
    );
  }
}

CommissionBadge.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
};
export default CommissionBadge;



// WEBPACK FOOTER //
// src/routes/commissions/components/CommissionBadge.js